import Vue from 'vue'
import Vuex from 'vuex'
import * as mutations from './mutations'

Vue.use(Vuex)

const state = {
  user: {
    username: null,
    role_name: null,
    token: null
  },
  url: location.protocol + '//' + window.location.hostname,
  // url: 'https://photo.extensionsoft.biz',
  // url: 'http://188.166.254.123',
  os: null,
  config: null,
  uploads: []
}

const store = new Vuex.Store({
  mutations,
  state
})

export default store



// WEBPACK FOOTER //
// ./src/Vuex/store.js